// extracted by mini-css-extract-plugin
export var chip = "_3d-0";
export var filterDropdown = "_3d-5";
export var filterItem = "_3d-6";
export var icon = "_3d-1";
export var removeButton = "_3d-3";
export var removeIcon = "_3d-4";
export var separator = "_3d-2";